<template>
    <main>

        <div class="login-body">

            <div class="login-background"></div>

            <router-link to="/">
                <img class="login-branding" src="/images/company-portal/logo.svg">
            </router-link>

            <div class="login-window">
                <div>
                    <h1 class="mb-2">Begär ett nytt lösenord</h1>
                    <p class="mb-8">Begär en återställningslänk för att ändra ditt lösenord. Länken är aktiv i 24 timmar.</p>
                </div>

                <div class="alert alert-success" v-if="success">
                    En återställningslänk har skickats till din e-post.
                </div>

                <form @submit.prevent="posterPost">

                    <input-text
                        type="email"
                        name="email"
                        label="E-postadress"
                        form-group-class="mb-4"
                        v-model="email"
                        :float-label="true"
                    />

                    <input type="submit" value="Skicka återställningslänk" class="btn btn-primary float-end" :disabled="success || poster.submitted">

                </form>
            </div>
        </div>
    </main>
</template>

<script>

import poster from '../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    data () {
        return {
            email: '',
            success: false
        }
    },

    computed: {
        posterUrl () {
            return '/password/email'
        },
        posterData () {
            return {
                email: this.email
            }
        }
    },

    methods: {
        posterSuccess () {
            this.success = true
        }
    }

}
</script>
